import {
  declaredAbsentInstancesAt,
  pinnedInstance,
  type EquipmentDefault,
  type LocationUnavailable,
} from '@heraion/shared';
import { getKnownLocations, getSilentInstanceForSlug } from './useEntryHistory';

// EQ-1: the one silent-machine rule for a newborn entry (add, replace, plan
// start). Kept out of useEntryHistory so that module stays the cache reader.

/** The place a session opens at: the last one trained at, or null when cold. */
export function getLastKnownPlace(): string | null {
  return getKnownLocations()[0]?.value ?? null;
}

/** History picks the machine, minus what was declared absent at `place`, with
 *  the athlete's pin for that place winning. */
export function getSilentInstanceAt(
  slug: string,
  place: string | null,
  locationUnavailable?: LocationUnavailable,
  equipmentDefault?: EquipmentDefault,
): string | null {
  return getSilentInstanceForSlug(
    slug,
    declaredAbsentInstancesAt(locationUnavailable, place, slug),
    place,
    pinnedInstance(equipmentDefault, place, slug),
  );
}
